export default "__VITE_ASSET__DFgFxgCN__"